export default __webpack_public_path__ + "static/media/professtionalLiability.61057418.png";